import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

export const isDifficultAviaRoute = (
  directions?: DifficultRoute[] | null,
): boolean => (directions?.length ?? 0) > 1
